//  @/store/modules/items.js
import Vue from 'vue'

const state = {
  categories: {
    mfp: {
        in: [
            'MFP - MONOCHROME',
            'MFP - COLOUR',
        ],
        value: 'MFP',
        text: 'Copieur',
    },
    printer: {
        in: [
            'PRINTERS',
        ],
        value: 'PRN',
        text: 'Imprimante',
    },
    prod: {
      in: [
        'PRODUCTION - MONOCHROME',
        'PRODUCTION - COLOUR',
      ],
      value: 'PROD',
      text: 'Appareil de production',
    },
    acc: {
        in: [
            'ACCESSORIES',
            'FINISHER',
            'CONSUMABLES',
            'RIP',
        ],
        value: 'ACC',
        text: 'Accessoire',
    },
    fee: {
        in: [
            'PROFESSIONAL SERVICES',
            'FEES',
            'WARRANTY',
        ],
        value: 'FEE',
        text: 'Frais',
    },
  },
  stopWords: [
    'BIZHUB'
  ],    
  headers: [
    {
    value: "vendor",
    text: "Fournisseur",
    values: ["vendor", "fournisseur"]
    },
    {
    value: "model",
    text: "Modèle",
    values: ["model", "modèle"]
    },
    {
    value: "description",
    text: "Description",
    values: ["modeldescr"]
    },
    {
    value: "sku",
    text: "SKU",
    values: ["itemnumber"]
    },
    {
    value: "cost",
    text: "Prix coûtant",
    values: ["ldn"]
    },
    {
    value: "msrp",
    text: "Prix coûtant",
    values: ["msrp", "srp", "pdsf"]
    },
    {
    value: "category",
    text: "Catégorie",
    values: ["category", "catégorie"]
    },
    {
    value: "categories",
    text: "Catégorie(s)",
    values: ["categories", "catégories"]
    },
    {
    value: "baseModel",
    text: "Modèle de base",
    values: ["basemodel"]
    },
    {
    value: "id",
    text: "Identifiant Firestore",
    values: ["id"]
    },
    {
    value: "launchDate",
    text: "Mise en marché",
    values: ["launchdate"]
    },
    {
    value: "effectiveDate",
    text: "Entrée en vigueur",
    values: ["effectiveDate", "effDate"]
    },
    {
    value: "expiryDate",
    text: "Expiration",
    values: ["expiryDate"]
    },
    {
    value: "lastUpdate",
    text: "Dernière MAJ",
    values: ["lastUpdate"]
    },
    {
    value: "type",
    text: "Type",
    values: ["type"]
    },
    {
    value: "color",
    text: "Couleur",
    values: ["color"]
    },
    {
    value: "comment",
    text: "Commentaire",
    values: ["comment", "comments"]
    },
  ],
  fileHeaders: [
    {
      value: "model",
      text: "Modèle",
    },
    {
      value: "cpp",
      text: "CPP",
    },
    {
      value: "bliId",
      text: "BLI",
    },
  ],
  bliHeaders: [
    {
      value: "bliId",
      values: ["INFORMATION DOCUMENTAIRE"]
    },
    {
      value: "prevVersion",
    values: ["Modèle Precedent"]
    },
    {
      value: "newVersion",
    values: ["Modèle qui remplace"]
    },
    {
      value: "monthlyStd",
    values: ["Volume mensuel recommandé"]
    },
    {
      value: "monthlyMax",
    values: ["Coefficient d'utilisation mensuel maximal"]
    },
    {
      value: "type",
    values: ["TYPE"]
    },
    {
      value: "technolology",
    values: ["Technologie"]
    },
    {
      value: "firstCopyHandling",
    values: ["Temps de première copie"]
    },
    {
      value: "multiCopy",
    values: ["Multicopie (LTR/LGL/LDGR)"]
    },
    {
      value: "preHeating",
    values: ["Temps de préchauffage"]
    },
    {
      value: "stdPaperSources",
    values: ["Source(s) de papier std"]
    },
    {
      value: "stdPaperCap",
    values: ["Capacité de papier std"]
    },
    {
      value: "maxPaperCap",
    values: ["Capacité de papier maxi"]
    },
    {
      value: "stdPaperWeight",
    values: ["Grammages du papier"]
    },
    {
      value: "stdPaperDeviationPerWeight",
    values: ["Déviation / grammages du papier"]
    },
    {
      value: "maxPaperSources",
    values: ["Sources de papier maxi"]
    },
    {
      value: "maxInputFormat",
    values: ["Formats d'origine maxi"]
    },
    {
      value: "maxOutputFormat",
    values: ["Format de sortie (mini/maxi)"]
    },
    {
      value: "copyRes",
    values: ["Résolution de la copie"]
    },
    {
      value: "systemMem",
    values: ["System Memory (Std/Max)"]
    },
    {
      value: "duplex",
    values: ["Duplex"]
    },
    {
      value: "duplexPaperFormats",
    values: ["Capacité duplex / formats papier"]
    },
    {
      value: "paperFeeder",
    values: ["Chargeur de documents"]
    },
    {
      value: "paperFeederCap",
    values: ["Capacité du chargeur de documents"]
    },
    {
      value: "finisher",
    values: ["Module de finition"]
    },
    {
      value: "finisherFeatures",
    values: ["Bac / agrafage / position(s)"]
    },
    {
      value: "otherPaperHandlingFeatures",
    values: ["Autres"]
    },
    {
      value: "userAuth",
    values: ["Authentification d'utilisateur du réseau"]
    },
    {
      value: "ipFiltering",
    values: ["Filtrage d'adresse IP"]
    },
    {
      value: "macFiltering",
    values: ["Filtrage d’adresse MAC"]
    },
    {
      value: "hddOverwriting",
    values: ["Écrasement HDD"]
    },
    {
      value: "maxHddOverwriting",
    values: ["Écrasements maxi"]
    },
    {
      value: "hddCrypting",
    values: ["Chiffrement HDD"]
    },
    {
      value: "securePrinting",
    values: ["Impression sécurisée"]
    },
    {
      value: "secureCryptedPrinting",
    values: ["Impression sécurisée et cryptée"]
    },
    {
      value: "cryptedPDFScaning",
    values: ["Mode PDF crypté (balayage crypté)"]
    },
    {
      value: "ipsec",
    values: ["Ipsec"]
    },
    {
      value: "ssl",
    values: ["Protocole SSL"]
    },
    {
      value: "snmpV3",
    values: ["SNMPv3"]
    },
    {
      value: "tls",
    values: ["Protocole TLS"]
    },
    {
      value: "ipsec",
    values: ["Ipsec"]
    },
    {
      value: "userInterface",
    values: ["PANNEAU DE CONTRÔLE"]
    },
    {
      value: "qtySelector",
    values: ["Sélecteur de quantité"]
    },
    {
      value: "promptScreen",
    values: ["Écran de messages"]
    },
    {
      value: "helpKey",
    values: ["Touche d'aide"]
    },
    {
      value: "automaticFunctions",
    values: ["Fonctions automatiques"]
    },
    {
      value: "bookCopy",
    values: ["Copie de livre"]
    },
    {
      value: "color",
    values: ["Couleur"]
    },
    {
      value: "hood",
    values: ["Capots"]
    },
    {
      value: "modifications",
    values: ["Modification"]
    },
    {
      value: "energySaver",
    values: ["Économie d’énergie"]
    },
    {
      value: "erase",
    values: ["Effacer"]
    },
    {
      value: "imageInsertion",
    values: ["Insertion d'image"]
    },
    {
      value: "imageRecovery",
    values: ["Recouvrement d'image"]
    },
    {
      value: "imageRepitition",
    values: ["Répétition d'image"]
    },
    {
      value: "imageRotation",
    values: ["Rotation d'image"]
    },
    {
      value: "halt",
    values: ["Interruption"]
    },
    {
      value: "tasksProgramming",
    values: ["Création de tâche"]
    },
    {
      value: "programmableTasks",
    values: ["Programmes de tâche"]
    },
    {
      value: "taskTime",
    values: ["Temps de tâche"]
    },
    {
      value: "interfaceLang",
    values: ["Langue"]
    },
    {
      value: "negPos",
    values: ["Nég / Pos"]
    },
    {
      value: "interfaceLang",
    values: ["Langue"]
    },
    {
      value: "transparent",
    values: ["Interfoliage de transparents"]
    },
    {
      value: "photoMode",
    values: ["Mode de photo"]
    },
    {
      value: "posterMode",
    values: ["Mode d'affiche"]
    },
    {
      value: "rePreset",
    values: ["Préréglage R/E"]
    },
    {
      value: "preProgramming",
    values: ["Programmation à l’avance"]
    },
    {
      value: "sheetInsertion",
    values: ["Insertion de feuille"]
    },
    {
      value: "stamping",
    values: ["Estampage"]
    },
    {
      value: "timer",
    values: ["Minuterie"]
    },
    {
      value: "dualMode",
    values: ["2 en 1"]
    },
    {
      value: "xyZoom",
    values: ["Zoom XY"]
    },
    {
      value: "zoomRange",
    values: ["Plage de zoom"]
    },
    {
      value: "otherFeatures",
    values: ["Autres fonctions"]
    },
    {
      value: "size",
    values: ["Dimensions (HxLxP)"]
    },
    {
      value: "weight",
    values: ["Poids"]
    },
    {
      value: "power",
    values: ["Alimentation"]
    },
    {
      value: "idlePower",
    values: ["Energie utilisée hors tension (watts)"]
    },
    {
      value: "energySaverPower",
    values: ["Energie utilisée en mode économie d'énergie (watts)"]
    },
    {
      value: "readyPower",
    values: ["Energie utilisée en mode prêt (watts)"]
    },
    {
      value: "printingPower",
    values: ["Energie utilisée lors de l'impression (watts)"]
    },
    {
      value: "copyPower",
    values: ["Energie utilisée lors de la copie (watts)"]
    },
    {
      value: "scanningPower",
    values: ["Energie utilisée lors de la numérisation (watts)"]
    },
    {
      value: "maxPower",
    values: ["Consommation d'énergie max. (watts)"]
    },
    {
      value: "energyStar",
    values: ["Conforme Energy Star"]
    },
    {
      value: "noise",
    values: ["Niveau de bruit d'opération"]
    },
    {
      value: "osCompatibility",
    values: ["Support du système d'exploitation"]
    },
    {
      value: "parallelPort",
    values: ["Interface parallèle"]
    },
    {
      value: "serialPort",
    values: ["Interface série"]
    },
    {
      value: "usbPort",
    values: ["Interface USB"]
    },
    {
      value: "interfaceType",
    values: ["Type d'interface"]
    },
    {
      value: "mobilePrinting",
    values: ["Prise en charge de l’impression mobile"]
    },
    {
      value: "nfc",
    values: ["Communication en champ proche"]
    },
    {
      value: "print",
    values: ["Imprimante"]
    },
    {
      value: "networkPrint",
    values: ["Imprimante réseau"]
    },
    {
      value: "usbPrint",
    values: ["Imprimer à partir d’une clé USB"]
    },
    {
      value: "scan",
    values: ["Scanneur"]
    },
    {
      value: "copy",
    values: ["Copieur"]
    },
    {
      value: "fax",
    values: ["Fax"]
    },
    {
      value: "pcFax",
    values: ["Fax de PC"]
    },
    {
      value: "networkFax",
    values: ["Fax de réseau"]
    },
    {
      value: "internetFax",
    values: ["Fax d'Internet"]
    },
    {
      value: "speed",
    values: ["Vitesse"]
    },
    {
      value: "scannerSpeed",
    values: ["Technologie / Vitesse de numérisation"]
    },
    {
      value: "scannerRes",
    values: ["Résolution maxi"]
    },
    {
      value: "scanToCloud",
    values: ["Cloud"]
    },
    {
      value: "scanToEmail",
    values: ["E-mail"]
    },
    {
      value: "scanToIFax",
    values: ["I-fax"]
    },
    {
      value: "scanToFTP",
    values: ["FTP"]
    },
    {
      value: "scanToSMB",
    values: ["SMB"]
    },
    {
      value: "scanToHDD",
    values: ["HDD"]
    },
    {
      value: "scanToURL",
    values: ["URL"]
    },
    {
      value: "scanToUSB",
    values: ["USB"]
    },
    {
      value: "ldap",
    values: ["Support de LDAP"]
    },
    {
      value: "supportedFileFormats",
    values: ["Formats de fichier pris en charge"]
    },
    {
      value: "scanningSoftware",
    values: ["Logiciel de balayage / image"]
    },
    {
      value: "ocrSoftware",
    values: ["Logiciel d’OCR"]
    },
    {
      value: "fileManagementSoftware",
    values: ["Logiciel de gestion de fichier"]
    }
  ],
  items: [],
}

const mutations = {
  SET_LISTENER (state, listener) {
    state.listener = listener
  },
  SET_ITEM (state, doc) {
    const data = doc.data()
    state.items = {
      ...state.items, 
      [doc.id]: data
    }
  },
  UPDATE_ITEM (state, doc) {
    state.items[doc.id] = doc.data()
  },
  DELETE_ITEM (state, doc) {
    Vue.delete(state.items, doc.id)
  },
}

const getters = {}

const actions = {
  async init({ commit, state, rootState }) {
    commit('SET_LISTENER', 
    rootState.db.collection('items').onSnapshot(snapshot => {
      let changes = snapshot.docChanges()
      changes.forEach(change => {
        let type = change.type
        let doc = change.doc
        
        if(type === 'added') commit('SET_ITEM', doc)
        else if(type === 'modified') commit('UPDATE_ITEM', doc)
        else if(type === 'removed') commit('DELETE_ITEM', doc)
      })
    }, (error) => {console.log(error.message)}))
  },
  async add({ rootState }, data) {
    let update = {
      time: new Date().toISOString(),
      user: rootState.auth.user.id,
      action: 'created',
    }

    data.updates = [ update ]

    let response = await rootState.db.collection('items').add(data)
    return response
  },
  async set({ rootState }, data) {
    let update = {
      time: new Date().toISOString(),
      user: rootState.auth.user.id,
      action: 'created',
    }

    data[1].updates = [ ...data[1].updates, update ]

    let ref = rootState.db.collection('items').doc(data[0])
    let response = await ref.set(data[1])
    return response
  },
  async delete({ rootState }, id) {
    let response = await rootState.db.collection('items').doc(id).delete()
    return response
  },
  setBatch({ commit, rootState }, documents) {
    let batches = []
    let i = 0

    //Itération à travers les éléments à traiter
    documents.forEach(document => {

      //Vérifier l'existance d'un lot de traitement pour le curseur courant
      if(!Boolean(batches[i])) batches[i] = []
      
      //Si le lot courant contient moins de 499 éléments, ajouter l'élément au lot
      if(batches[i].length < 499) batches[i].push(document)

      //Sinon, incrémenter le curseur, créer un nouveau lot et y ajouter l'élément
      else {
        i++
        batches[i] = []
        batches[i].push(document)
      }
    })

    //Pour chacun des lots...
    batches.forEach(b => {

      //Initialiser le lot...
      let batch = rootState.db.batch()

      //Traiter chaque élément du lot
      b.forEach(document => {
        let ref = rootState.db.collection('items').doc()
        return batch.set(ref, document)
      })

      //Exécuter le lot et faire une pause de 1 seconde suite à l'exécution
      batch.commit()
        .then(() => { setTimeout(() => { return }, 1000) })
        .catch(err => { console.log(err.message) })
    })
  },
  deleteBatch({ commit, rootState }, documents) {
    let batches = []
    let i = 0

    documents.forEach(document => {
      if(!Boolean(batches[i])) batches[i] = []
      
      if(batches[i].length < 499) batches[i].push(document)
      else {
        i++
        batches[i] = []
        batches[i].push(document)
      }
    })

    batches.forEach(b => {
      let batch = rootState.db.batch()
      b.forEach(document => {
        let ref = rootState.db.collection('items').doc(document)
        return batch.delete(ref)
      })

      batch.commit()
        .then(() => { setTimeout(() => { return }, 1000) })
        .catch(err => { console.log(err.message) })
    })
  },
  async close({ rootState }) { 
    let response = await rootState.db.collection('items').onSnapshot(() => {})
    return response
  },
}

export default { 
  namespaced: true, state, mutations, getters, actions
}